import { Box, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ProtectionZoneSummaryResponse } from "../../../types/model/protectionZone";

interface ProtectionZoneSummaryProps {
  protectionZoneSummaryData: ProtectionZoneSummaryResponse;
}

export function ProtectionZoneSummary({
  protectionZoneSummaryData
}: Readonly<ProtectionZoneSummaryProps>) {
  const { t } = useTranslation();

  return (
    <Stack spacing={2}>
      <Toolbar sx={{ pl: 2, pr: 1 }}>
        <Typography
          sx={{
            flex: "1 1 100%",
            fontSize: "1.5rem",
            fontWeight: 600,
          }}
          component="div"
        >
          {t("captures.capture.protection-zone.title")}
        </Typography>
      </Toolbar>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t("captures.capture.protection-zone.material")}</TableCell>
              <TableCell align="right">{t("captures.capture.protection-zone.quantity")}</TableCell>
              <TableCell align="right">{t("captures.capture.protection-zone.total-price")}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>{t("captures.capture.protection-zone.electrowelded-mesh")}</TableCell>
              <TableCell align="right">{protectionZoneSummaryData.totalPImediata ?? "-"}</TableCell>
              <TableCell align="right">
                {protectionZoneSummaryData.totalPrecoRedeCapt?.toFixed(2) ?? "-"} €
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>{t("captures.capture.protection-zone.bollards")}</TableCell>
              <TableCell align="right">{protectionZoneSummaryData.totalNPilaretes ?? "-"}</TableCell>
              <TableCell align="right">
                {protectionZoneSummaryData.totalPrecoPilaretesCapt?.toFixed(2) ?? "-"} €
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>{t("captures.capture.protection-zone.identification-sign")}</TableCell>
              <TableCell align="right">{protectionZoneSummaryData.totalNPlaca ?? "-"}</TableCell>
              <TableCell align="right">
                {protectionZoneSummaryData.totalPrecoPlacasCapt?.toFixed(2) ?? "-"} €
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: 1,
        }}
      >
        <Typography
          variant="body2"
          fontWeight={600}
          color="primary.main"
        >
          {t("captures.capture.protection-zone.total-price")}
        </Typography>

        <Typography
          variant="body1"
          fontWeight={600}
          sx={{ minWidth: 80, textAlign: "right" }}
        >
          {protectionZoneSummaryData?.totalPrecoCapt == null
            ? "-"
            : `${protectionZoneSummaryData.totalPrecoCapt.toFixed(2)} €`}
        </Typography>
      </Box>
    </Stack>
  );
}